import type { GeneratedRoofSystem, GeneratedRoof } from "building-types/roofs/generatedRoofSystemTypes";
import type { Table } from "common/data/table";

export function roofsOnLevel(levelId: string, roofSystems: Table<GeneratedRoofSystem>): GeneratedRoof[] {
  const roofs: GeneratedRoof[] = [];

  for (const roofId in roofSystems) {
    const roofSystem = roofSystems[roofId];

    const { roofs: subRoofs } = roofSystem;
    for (const subRoofId in subRoofs) {
      const subRoof = subRoofs[subRoofId];

      if (subRoof.levelId === levelId) {
        roofs.push(subRoof);
      }
    }
  }
  return roofs;
}
